import { createSvg } from '../createSvg';
var Broom = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return <>
        <g id={'guts'}>
            <path d='M9.87006 5.66998L6.45006 7.74999L4.89007 5.19C4.32007 4.25 4.62006 3.01 5.56006 2.44C6.50006 1.87 7.74006 2.16998 8.31006 3.10998L9.87006 5.66998Z' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M11.8201 9.15997L8.66012 11.08C6.82012 12.2 6.26011 14.46 7.15011 16.26L9.20011 20.44C9.86011 21.79 11.4601
             22.26 12.7401 21.47L19.1701 17.56C20.4601 16.78 20.7701 15.15 19.8801 13.94L17.1101 10.2C15.9101 8.58001 13.6601 8.03997 11.8201 9.15997Z' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M10.7567 5.09797L5.63208 8.21857L7.71248 11.635L12.8371 8.51437L10.7567 5.09797Z' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M14.3101 16.81L15.9601 19.52' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M11.75 18.37L13.4 21.08' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M16.8701 15.25L18.5201 17.96' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>
    </>;
};
export default createSvg(Broom, 'broom');
